/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

const Access = {
  APLICATION: 496,
  MENU_ACCESS: {
    DASHBOARD: 317,
    ENQUIRIES: 318,
    MANAGEMENT: 462
  },
  PERSON_EDIT: "457",

  MANAGEMENT: {
    READ: 462,
    MODULE_PERSON: 994,
    MODULE_ACCESS_GROUP: 995,
    MODULE_ACCESS_PROFILE: 996,
    CREATE_PERSON: 457,
    EDIT_PERSON: 311,
  },
  MANAGEMENT_PERSON: {
    READ: 994,
    CREATE_PERSON: 457,
    EDIT_PERSON: 311,
    EDIT_USER: 1069,
    CREATE_USER: 1070,
  },
  MANAGEMENT_USER:{
    READ: 1080,
    EDIT_USER: 1069,
    CREATE_USER: 1070
  },
  MANAGEMENT_ACCESS_GROUP: {
    READ: 995
  },
  MANAGEMENT_PROFILE: {
    READ: 996
  },

  LIST: {
    CREATE_ENQUIRY: 428,
    EDIT_ENQUIRY: 429,
    EDIT_ENQUIRY_SAVE: 430,
    EDIT_ENQUIRY_GENERATE_NBI_REQUEST: 431,
    DOCUMENT_GENERAL: 313,
    NBI_REQUEST_APPROVE_REJECT: 433,
    MARKETS_SELECTION: 436,
    MARKETS_SELECTION_GENERATE_NBI: 437,
    ORDER_TO_BIND_GENERATE: 421,
    ORDER_TO_BIND_APPROVE_REJECT: 422,
  },

  ROUTE_CREATEENQUIRITY: {
    CREATE_ENQUIRY: 428,
    DOCUMENT_GENERAL: 313,
    EDIT_ENQUIRY: 429,
    NBI_REQUEST_APPROVE_REJECT: 433,
  },

  ROUTE_EDITENQUIRITY: {
    CREATE_ENQUIRY: 428,
    EDIT_ENQUIRY: 429,
    EDIT_ENQUIRY_SAVE: 430,
    EDIT_ENQUIRY_GENERATE_NBI_REQUEST: 431,
    NBI_REQUEST_APPROVE_REJECT: 433,
    MARKETS_SELECTION: 436,
    MARKETS_SELECTION_GENERATE_NBI: 437,
    DOCUMENT_GENERAL: 313,
  },

  ROUTE_QUOTESPLANS: {
    NBI_REQUEST_APPROVE_REJECT: 433,
    MARKETS_SELECTION: 436,
    MARKETS_SELECTION_GENERATE_NBI: 437,
    DOCUMENT_GENERAL: 313,
    EDIT_ENQUIRY: 429,
  },

  ROUTE_PAYMENT: {
    MARKETS_SELECTION: 436,
    MARKETS_SELECTION_GENERATE_NBI: 437,
    ORDER_TO_BIND_GENERATE: 421,
    EDIT_ENQUIRY: 429,
    NBI_REQUEST_APPROVE_REJECT: 433
  },

  ROUTE_QUOTE_ISSUE: {
    ORDER_TO_BIND_APPROVE_REJECT: 422,
    EDIT_ENQUIRY: 429,
  },

  ROUTE_DOCUMENTMANAGEMENT: {
    DOCUMENT_GENERAL: {
      ID_DOMAIN: 313,
      PERMISSIONS: ["READ", "CREATE", "DELETE"],
    }
  },

  BROKER_SENIOR_APPROVAL: "417",
  CREATE_FRAMEWORK: "460",
  APPROVAL_NBI: {
    NBI_SEND_APPROVAL: 440,
    NBI_APPROVE_REJECT: 441,
  },

  APPROVE_REJECT_POLICY_PACK: {
    READ: 413,
    APPROVE_REJECT_INTERNALLY: 414,
    APPROVE_REJECT_CLIENT: 415,
    GENERATE_WORDING: 416,
    POLICY_PACK_SEND_INTERNALLY: 418,
    POLICY_PACK_SEND_INSURER: 419,
    POLICY_PACK_SEND_CLIENT: 420,
  },

  ENDORSEMENTS: {
    ENDORSEMENT_PACK_APPROVE_REJECT: 465,
    ENDORSEMENT_PACK_APPROVE_REJECT_INTERNALLY: 466,
    ENDORSEMENT_PACK_APPROVE_REJECT_CLIENT: 467,
    ENDORSEMENT_PACK_SEND_INTERNALLY: 468,
    ENDORSEMENT_PACK_SEND_CLIENT: 470,
    ENDORSEMENT_PACK_SEND_INSURER: 469,
  },

  MARKET_COMPOSITION: {
    MARKETING_COMPOSITION: 442,
    GENERATE_WORDING: 416,
    GENERATE_MRC: 427,
    MARKETING_COMPOSITION_SAVE: 443,
    EXPORT_SCHEDULE: 444,
    IMPORT_SCHEDULE: 445,
  },

  MARKET_SELECTION: {
    SELECT_MARKETS: 434,
    MARKETS_SELECTION: 436,
    MARKETS_SELECTION_GENERATE_NBI: 437,
    MARKETS_SELECTION_RESEND: 438,
    MARKETS_SELECTION_ANSWER_AS_INSURER: 439,
  },

  PAYMENT_PACK: {
    PAYMENT_PACK_SEND_INTERNALLY: 425,
    PAYMENT_PACK_SEND_EXTERNALLY: 426,
    PAYMENT_PACK_READ: 447,
    PAYMENT_PACK_CREATE: 424,
  },

  POLICIES: {
    POLICIES_CREATE_ENDORSEMENT: 476,
    POLICIES_EDIT: 477,
  },

  SCHEDULE: {
    IMPORT_SCHEDULE: 445,
  },

  SEND_POLICY_PACK_INTERNALLY: {
    READ: 388,
    SEND: 388,
  },

  SEND_WORDING: {
    MARKETING_COMPOSITION: 442,
    GENERATE_MRC: 427,
  },

  STAMPS_REQUEST: {
    EXECUTION: 446,
    ENDORSEMENT_PACK_SEND_DIRECTOR_APPROVAL: 475,
  },

  ROUTE_QUOTELETTER: {
    MARKETS_SELECTION: 436,
    MARKETS_SELECTION_GENERATE_NBI: 437,
    EDIT_ENQUIRY: 429,
    DOCUMENT_GENERAL: 313,
  },

};

export default Access;
